export default {
  EE: 'EE', //"Promo"
  EB: 'EB', //"Base"
  EP: 'EP', //"Plus"
  EA: 'EA', //"Puente Aereo"
  PE: 'PE' //"Club Economy"
}
